/* eslint no-shadow: ["error", {"allow": ["getters"]}] */
import _ from 'lodash';

const getters = {
  getDefaultFromQueryStringParmIfInitialPageLoad: (state, getters, rootState) =>
    (defaultValue, queryStringKey) => {
      // console.log('getDefaultFromQueryStringParmIfInitialPageLoad initialPageLoad: %s, ' +
      //   'defaultValue: %s, queryStringKey: %s, qsVal: %s',
      //   rootState.flags.initialPageLoad, defaultValue,
      //   queryStringKey, state.query[queryStringKey]);
      if (rootState.flags.initialPageLoad) {
        return state.query[queryStringKey] || defaultValue;
      }
      return defaultValue;
    },
  getDefaultFromQueryStringPnlParmIfInitialPageLoad: (state, getters, rootState) =>
    (defaultValue, instance, panelStringKey) => {
      // pnl0, pnl1, etc. QS parms are csv lists with fields in this order:
      const mapping = {
        view: 0,
        allYears: 1,
        yearId: 2,
        stratCatId1: 3,
        stratId1: 4,
        stratCatId2: 5,
        stratId2: 6,
        responseId: 7,
        dataValueTypeId: 8,
      };
      let val = defaultValue;
      if (rootState.flags.initialPageLoad) {
        // get panel query string for this panel instance
        const panelQS = state.query[`pnl${instance}`];
        if (panelQS) {
          // if the panel query string exists, split the csv string into an array
          const panelQSArr = panelQS.split(',');
          if (panelQSArr.length === _.size(mapping)) {
            // the array length matches the expected length
            if (mapping[panelStringKey] !== undefined) {
              // the panelStringKey is valid
              val = panelQSArr[mapping[panelStringKey]];
              if (typeof defaultValue === 'boolean') {
                // default value was a boolean, so convert to boolean
                val = (val === 'true');
              }
            }
          }
        }
      }
      return val;
    },
};

export default {
  getters,
  // namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/route.js